// $('[data-toggle="popover"]').popover();



//Permet un changement de image au hover
// const $ = jQuery;
//
// const hoverElement = $('.js-hovering');
// hoverElement.on('mouseenter', function () {
//     changeSrc($(this).children('img'), 'hoverin');
// });
//
// hoverElement.on('mouseleave', function () {
//     changeSrc($(this).children('img'), 'hoverout');
// });
//
// const changeSrc = ($element, attr) => {
//     const img = $element.data(attr);
//     $element.attr('src',img);
// }
